import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-land-transport-service',
  templateUrl: './land-transport-service.component.html',
  styleUrls: ['./land-transport-service.component.scss']
})
export class LandTransportServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
